import { createAction, props } from '@ngrx/store';
import { ActionPayload } from "@hrra/core";


export enum Actions {
    LoadSpecializations = '[Specialization picker] load specialization',

    ToggleExpandHeadSpecialization = '[Specialization picker] toggle expand head specialization',

    SelectSpecialization = '[Specialization picker] select specialization ',
    UnselectSpecialization = '[Specialization picker] unselect specialization',
    RemoveSpecialization = '[Specialization picker] remove specialization',

    FilterSpecializations = '[Specialization picker] filter specialization',

    ResetSpecializationFilter = '[Specialization picker] reset specialization filter'

}

export const loadSpecializations = createAction(
    Actions.LoadSpecializations,
    props<ActionPayload<{ specializationIds: string[] }>>()
);

export const toggleExpandHeadSpecialization = createAction(
    Actions.ToggleExpandHeadSpecialization,
    props<ActionPayload<{ specializationId: string }>>()
);

export const selectSpecialization = createAction(
    Actions.SelectSpecialization,
    props<ActionPayload<{ specializationId: string}>>()
);

export const unselectSpecialization = createAction(
    Actions.UnselectSpecialization,
    props<ActionPayload<{ specializationId: string}>>()
);

export const removeSpecialization = createAction(
    Actions.RemoveSpecialization,
    props<ActionPayload<{ specializationId: string}>>()
);

export const filterSpecializations = createAction(
    Actions.FilterSpecializations,
    props<ActionPayload<{ query: string }>>()
);

export const resetSpecializationFilter = createAction(
    Actions.ResetSpecializationFilter
);